import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

import addressBookReducer from '../reducers/addressBook';
import alertUserReducer from '../Containers/AlertUser/reducers';
import authReducer from '../Containers/Auth/reducer';
import channelsReducer from '../Containers/Channels/channelsReducer';
import chatReducer from '../Containers/Channels/chatReducer';
import discoverReducer from '../Containers/Discover/discoverReducer';
import eventsReducer from '../Containers/Events/reducer';
import fbAuthReducer from './firebase';
import momentsReducer from '../Containers/Moments/momentsReducer';
import notificationsReducer from '../Containers/Notifications/notificationsReducer';
import profileReducer from '../Containers/Profile/profileReducer';
import usersReducer from '../Containers/Channels/usersReducer';

import activeModulesReducer from './activeModules';
import eventwideReducer from './eventwide';
import scheduleReducer from '../Containers/Schedule/scheduleReducer';
import uiReducer from '../redux/ui/reducer';
import firebaseUserInfoReducer from '../reducers/firebaseUserInfo';

export default (history: any) =>
    combineReducers({
        activeModules: activeModulesReducer,
        addressBook: addressBookReducer,
        alertUser: alertUserReducer,
        auth: authReducer,
        channels: channelsReducer,
        chat: chatReducer,
        discover: discoverReducer,
        events: eventsReducer,
        eventwide: eventwideReducer,
        fbAuth: fbAuthReducer,
        form: formReducer,
        moments: momentsReducer,
        notifications: notificationsReducer,
        profile: profileReducer,
        router: connectRouter(history),
        schedule: scheduleReducer,
        ui: uiReducer,
        users: usersReducer,
            firebaseUserInfo: firebaseUserInfoReducer
    });
